import { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Observable } from 'rxjs';

/**
 * Interface that form components must implement to enable dirty-form guarding.
 */
export interface DirtyFormComponent {
  isDirty(): boolean;
}

/**
 * Functional canDeactivate guard that prompts the user when navigating away
 * from a form with unsaved changes.
 */
export const canDeactivateDirtyForm: CanDeactivateFn<DirtyFormComponent> = (
  component,
) => {
  if (!component.isDirty()) {
    return true;
  }

  const confirmationService = inject(ConfirmationService);

  return new Observable<boolean>((observer) => {
    confirmationService.confirm({
      message:
        'You have unsaved changes. Are you sure you want to leave? All changes will be lost.',
      header: 'Discard Changes',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Discard',
      rejectLabel: 'Keep Editing',
      acceptButtonStyleClass: 'p-button-danger p-button-text',
      rejectButtonStyleClass: 'p-button-text',
      accept: () => {
        observer.next(true);
        observer.complete();
      },
      reject: () => {
        observer.next(false);
        observer.complete();
      },
    });
  });
};
